import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

export interface RemoveDialogInput {
  canDeleteMilestone?: {
    endDate: null | string;
    startDate: null | string;
  };
  cannotDeleteMessage: string;
  clickRouteCallback?: (name: string) => void;
  routeInputs: RouteInput[];
}

export interface RouteInput {
  componentName: string;
  link: string;
  name: string[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, DatePipe],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    <div [innerHTML]="cannotDeleteMessage"></div>

    @for (route of routeInputs; track route.link) {
      <div class="mb-4">
        <br />
        {{ route.componentName }}
        <br />
        <ul class="list-disc pl-4">
          @for (name of route.name; track name) {
            @if (name) {
              <li>
                <a
                  class="aux-link cursor-pointer"
                  [routerLink]="[route.link]"
                  (click)="onRouteClick(name)"
                >
                  {{ name }}
                </a>
              </li>
            }
          }
        </ul>
      </div>
    }

    @if (canDeleteMilestone?.startDate) {
      <div class="mt-2">
        Trial Timeline cannot be shifted after
        {{ canDeleteMilestone?.startDate | date: 'MM/dd/YYYY' }}
      </div>
    }
    @if (canDeleteMilestone?.endDate) {
      <div class="mt-2">
        Trial Timeline cannot be shifted before
        {{ canDeleteMilestone?.endDate | date: 'MM/dd/YYYY' }}
      </div>
    }
  `,
})
export class RemoveDialogComponent {
  ref = inject<CustomOverlayRef<unknown, RemoveDialogInput>>(CustomOverlayRef);

  canDeleteMilestone: RemoveDialogInput['canDeleteMilestone'] = { endDate: null, startDate: null };
  cannotDeleteMessage: string;
  routeInputs: RouteInput[];

  constructor() {
    const ref = this.ref;

    this.cannotDeleteMessage = ref.data?.cannotDeleteMessage || '';
    this.routeInputs = ref.data?.routeInputs || [];
    this.canDeleteMilestone = ref.data?.canDeleteMilestone || { endDate: null, startDate: null };
  }

  onRouteClick(name: string): void {
    this.ref.data?.clickRouteCallback?.(name);
    this.ref.close();
  }
}
